
import React from 'react'

// components
import {
  CRow,
  CCol,
  CFormLabel,
  CImage,
  CButton,
  CAccordion, 
  CAccordionBody, 
  CAccordionHeader, 
  CAccordionItem
} from '@coreui/react-pro'

import FormSelectInput from './FormSelectInput'
import FormTextInput from './FormTextInput'

// icons
import AddMoreIconWhite from '../../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from 'src/components/custom-styles/buttonStyles'

const FormEmployeeEducation = ({
  colSize,
  inputLabel,
  className,
  degreeOptions,
  countryOptions,
  employeeEducations,
  handleAddEmployeeEducations,
  errors,
  handleChangeEducation,
  handleSelectEducation,
  handleRemoveEmployeeEducation,
  disabled
}) => {
  return (
    <CCol lg={colSize} className={className}>
      <div className='mb-3 d-grid gap-2 d-md-flex justify-content-between align-items-center'>
        <CFormLabel>
          {inputLabel}
        </CFormLabel>
        {
          !disabled && (
            <CButton
              onClick={() => handleAddEmployeeEducations()}
              style={styleButtonVars2}
            >
              <CImage fluid src={AddMoreIconWhite} className='me-2' />
              {employeeEducations?.length > 0 ? 'Add More' : 'Add'}
            </CButton>
          )
        }
      </div>
      {employeeEducations?.length > 0 && (
        employeeEducations?.map((inputField, index) => {
          return (
            <CAccordion>
              <CAccordionItem itemKey={index+1} className='mb-2'>
                <CAccordionHeader>Education {index + 1}</CAccordionHeader>
                <CAccordionBody>
                  <CRow className='mb-3'>
                    <CCol lg={3}>
                      <CFormLabel>
                        Degrees Type
                      </CFormLabel>
                    </CCol>
                    <CCol>
                      <FormSelectInput 
                        id='degree_type'
                        name='degree_type'
                        colSize='6'
                        inputLabel='Degrees Type'
                        isShowLabel={false}
                        selectOptions={degreeOptions}
                        value={inputField?.degree_type}
                        handleSelectInput={(e) => handleSelectEducation(e, 'degree_type', index)}
                        feedbackInvalid={!disabled && errors.employee_educations?.length > 0 ? errors?.employee_educations[index].degree_type : null}
                        invalid={!disabled && errors.employee_educations?.length > 0 ? errors?.employee_educations[index].degree_type : null}
                        disabled={disabled}
                        placeholder='Please select degree type...'
                      />
                    </CCol>
                  </CRow>
                  <CRow className='mb-3'>
                    <CCol lg={3}>
                      <CFormLabel>
                        Field of study
                      </CFormLabel>
                    </CCol>
                    <CCol>
                      <FormTextInput 
                        id='field_of_study'
                        name='field_of_study'
                        colSize='6'
                        placeholder='Enter field of study...'
                        value={inputField.field_of_study}
                        disabled={disabled}
                        handleTextInput={(e) => handleChangeEducation(e, index)}
                        feedbackInvalid={!disabled && errors.employee_educations?.length > 0 ? errors?.employee_educations[index].field_of_study : null}
                        invalid={!disabled && errors.employee_educations?.length > 0 ? errors?.employee_educations[index].field_of_study : null}
                      />
                    </CCol>
                  </CRow>
                  <CRow className='mb-3'>
                    <CCol lg={3}>
                      <CFormLabel>
                        Institution Name
                      </CFormLabel>
                    </CCol>
                    <CCol>
                      <FormTextInput 
                        id='institution_name'
                        name='institution_name'
                        colSize='6'
                        placeholder='Enter institution name...'
                        value={inputField.institution_name}
                        disabled={disabled}
                        handleTextInput={(e) => handleChangeEducation(e, index)}
                        feedbackInvalid={!disabled && errors.employee_educations?.length > 0 ? errors?.employee_educations[index].institution_name : null}
                        invalid={!disabled && errors.employee_educations?.length > 0 ? errors?.employee_educations[index].institution_name : null}
                      />
                    </CCol>
                  </CRow>
                  <CRow className='mb-3'>
                    <CCol lg={3}>
                      <CFormLabel>
                        Graduation Year
                      </CFormLabel>
                    </CCol>
                    <CCol>
                      <FormTextInput 
                        id='graduation_year'
                        name='graduation_year'
                        colSize='6'
                        placeholder='Enter graduation year...'
                        value={inputField.graduation_year}
                        disabled={disabled}
                        handleTextInput={(e) => handleChangeEducation(e, index)}
                        feedbackInvalid={!disabled && errors.employee_educations?.length > 0 ? errors?.employee_educations[index].graduation_year : null}
                        invalid={!disabled && errors.employee_educations?.length > 0 ? errors?.employee_educations[index].graduation_year : null}
                      />
                    </CCol>
                  </CRow>
                  <CRow className='mb-5'>
                    <CCol lg={3}>
                      <CFormLabel>
                        Country of Institution
                      </CFormLabel>
                    </CCol>
                    <CCol>
                      <FormSelectInput 
                        id='country_value'
                        name='country_value'
                        colSize='6'
                        inputLabel='Country of Institution'
                        isShowLabel={false}
                        selectOptions={countryOptions}
                        value={inputField?.country_value}
                        handleSelectInput={(e) => handleSelectEducation(e, 'country_value', index)}
                        feedbackInvalid={!disabled && errors.employee_educations?.length > 0 ? errors?.employee_educations[index].country_value : null}
                        invalid={!disabled && errors.employee_educations?.length > 0 ? errors?.employee_educations[index].country_value : null}
                        disabled={disabled}
                        placeholder='Please select country of institution...'
                      />
                    </CCol>
                  </CRow>
                  {
                    employeeEducations?.length > 1 && (
                      <CButton
                        style={styleButtonVars2}
                        onClick={() => {handleRemoveEmployeeEducation(inputField, index)}}
                      >
                        Delete Education
                      </CButton>
                    )
                  }
                </CAccordionBody>
              </CAccordionItem>
            </CAccordion>
          )
        })
      )}
    </CCol>
  )
}

export default FormEmployeeEducation
